import React from "react";
import { Input } from "@/components/ui/input";
import { Bookmark, BookmarkSimple, Trash, Plus } from "@phosphor-icons/react";

// Preset library sidebar section: save the current layout as a named preset
// then apply/delete via the list below. Callbacks are owned by the parent
// so we stay presentational (easier to unit test in Storybook later).
export default function PresetLibraryPanel({
  presets, presetName, onPresetNameChange,
  onSaveAsPreset, onApplyPreset, onDeletePreset,
}) {
  return (
    <div className="border-t border-border pt-3 mt-4">
      <div className="overline mb-2 flex items-center gap-1">
        <BookmarkSimple size={12} /> Preset Library
      </div>
      <div className="flex gap-1 mb-3">
        <Input
          value={presetName}
          onChange={(e) => onPresetNameChange(e.target.value)}
          placeholder="Nama preset..."
          className="rounded-xl h-8 text-xs"
          data-testid="preset-name-input"
        />
        <button
          onClick={onSaveAsPreset}
          className="px-2 h-8 bg-primary text-primary-foreground hover:bg-primary/90 flex items-center text-xs font-bold uppercase"
          data-testid="save-preset-button"
          title="Simpan layout saat ini sebagai preset"
        >
          <Plus size={14} weight="bold" />
        </button>
      </div>
      <div className="max-h-40 overflow-y-auto space-y-1 mb-4">
        {presets.length === 0 ? (
          <div className="text-xs text-muted-foreground italic px-1">Belum ada preset tersimpan.</div>
        ) : presets.map((p) => (
          <div
            key={p.id}
            className="flex items-center gap-1 border border-border p-1.5 bg-secondary/30"
            data-testid={`preset-row-${p.id}`}
          >
            <div className="flex-1 min-w-0">
              <div className="text-xs font-semibold truncate">{p.name}</div>
              <div className="text-[10px] font-mono text-muted-foreground truncate">{p.created_by}</div>
            </div>
            <button
              onClick={() => onApplyPreset(p)}
              className="px-2 h-7 border border-border hover:bg-primary hover:text-primary-foreground text-[10px] font-bold uppercase"
              data-testid={`apply-preset-${p.id}`}
              title="Terapkan preset ini"
            >
              <Bookmark size={12} />
            </button>
            <button
              onClick={() => onDeletePreset(p)}
              className="px-2 h-7 border border-border hover:bg-destructive hover:text-destructive-foreground text-destructive"
              data-testid={`delete-preset-${p.id}`}
              title="Hapus preset"
            >
              <Trash size={12} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
